<div class="w-full text-sm p-2">
    <span class="inline text-gray-900 font-medium">
        Suggested Functions:
    </span>
    <span *ngFor="let suggestion of suggestions">
        <span class="inline">
            <button 
                (click)="$event.preventDefault(); onClick(suggestion);"
                class="text-nside-gray-400 hover:text-nside-orange-400"
            >
                {{ suggestion }}
            </button>
        </span> | 
    </span>
</div>